import React, { useEffect } from 'react';

//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

//Iconos
import icn_01 from '../../assets/img/landingPage/connectors/connectors_02_connectivity.svg';
import icn_02 from '../../assets/img/landingPage/about/aboutUs_vision.png';
import icn_03 from '../../assets/img/landingPage/cloudP/icn_cloudP_03.png';
import icn_04 from '../../assets/img/landingPage/cloudP/icn_cloudP_04.png';
import icn_05 from '../../assets/img/landingPage/cloudP/icn_cloudP_05.png';
import icn_06 from '../../assets/img/landingPage/cloudP/icn_cloudP_06.png';
import icn_07 from '../../assets/img/landingPage/cloudP/icn_cloudP_07.png';
import icn_08 from '../../assets/img/landingPage/cloudP/icn_cloudP_08.png';


import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import key01 from '../../assets/img/landingPage/virtualServer/VirtualServer_01.png'
import key03 from '../../assets/img/landingPage/devStudio/DevStudio_01.png'
import key04 from '../../assets/img/landingPage/meshManager/MeshManager01.png'
import key05 from '../../assets/img/landingPage/vision/Vision03.png'
import key06 from '../../assets/img/landingPage/modeling/a2ml-04.png'


import dashboard from '../../assets/img/landingPage/cloud/Cloud-home.png';


import icn_vision from '../../assets/img/landingPage/about/aboutUs_vision.svg';
import icn_mision from '../../assets/img/landingPage/about/aboutUs_mision.svg';


const DigitalFabric = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'AVAP Virtual Server',
            text: "Enables decoupled orchestration of services, data, and legacy logic",
            altDescription: "Enables decoupled orchestration of services, data, and legacy logic",
            image: key01,
        },
        Key_Feature_02: {
            title: "AVAP Gateway Advanced",
            text: "Connects APIs across legacy systems, SaaS apps, and cloud environments",
            altDescription: "Connects APIs across legacy systems, SaaS apps, and cloud environments",
            image: product_gateway,
        },
        Key_Feature_03: {
            title: 'AVAP Dev Language',
            text: "Creates composable virtual APIs and services with reusable logic.",
            altDescription: 'Creates composable virtual APIs and services with reusable logic.',
            image: key03,
        },
        Key_Feature_04: {
            title: 'AVAP Mesh Manager',
            text: 
            "Provides visibility and control across your digital fabric.",
            altDescription: 'Provides visibility and control across your digital fabric.',
            image: key04,
        },
        Key_Feature_05: {
            title: 'AVAP Vision & AI Analytics',
            text: 
            "Offers real-time observability and process optimization",
            altDescription: 'Offers real-time observability and process optimization',
            image: key05,
        },
        Key_Feature_06: {
            title: 'AVAP Framework (iPaaS)',
            text: 
            "Integrates flows and business logic across multiple systems",
            altDescription: 'Integrates flows and business logic across multiple systems',
            image: key06,
        },
    }
    

    
    const items = [
        {
            icon: icn_01,
            title: 'What Is Digital Fabric?',
            paragraphs: [
              'Digital Fabric is a flexible integration architecture that connects services, applications, and data across your enterprise using APIs, events, and composable components. It’s not a product, it’s a strategy that supports agility, real-time data exchange, and modular system evolution.',
            ],
            paragraphs2: [
                'Key characteristics include:',
              ],
            bullets: [
              'Open APIs and standardized integrations',
              'Event-driven microservices',
              'iPaaS-style orchestration',
              'Loose coupling and interoperability',
              'The ability to evolve without breaking legacy systems',
            ],
           
            paragraphs3: [
              'A digital fabric enables modular, future-ready innovation without increasing technical debt.',
            ],
          },

        {
          icon: icn_02,
          title: 'What Is a Digital Integration Hub (DIH)?',
          paragraphs: [
            'A Digital Integration Hub decouples your backend systems (like mainframes or ERPs) from modern digital experiences. It enables real-time interactions while offloading legacy infrastructure.',
          ],
          paragraphs2: [
            'How it works:',
          ],
          bullets: [
            'Pulls and syncs data from core systems',
            'Stores that data in fast-access operational stores (cache/DB)',
            'Exposes functionality via APIs and events',
            'Supports real-time performance without stressing the core'
          ],
          paragraphs3: [
            'A DIH delivers responsive, API-enabled digital experiences, even if your backend isn’t ready for real-time demands.',
          ],
          
        },
        
      ];
      
    const breakpointColumnsObj = {
        default: 2, //Cambio de columnas verticales
        1100: 2,
        700: 1          
    };

    //Key UseCases Bento
    const items2 = [
        {
            icon: icn_03,
            title: 'SaaS Startups',
            paragraphs: [
              'Legacy capabilities are exposed via modern APIs.'
            ]
          },
        {
            icon: icn_04,
            title: 'Public Institutions & Education',
            paragraphs: [
              'Data is cached securely for real-time access.'
            ]
          },
        {
          icon: icn_05,
          title: 'Agencies and Integrators',
          paragraphs: [
            'Workflows are orchestrated through AVAP Virtual Server.',
          ]
        },
        {
            icon: icn_06,
            title: 'Fintech Startups',
            paragraphs: [
              'Apps, CRMs, and external systems are integrated via AVAP Gateway.',
            ]
          },      
         
      ];
      
    const breakpointColumnsObj2 = {
        default: 4, //Cambio de columnas verticales
        1100: 2,
        700: 1          
    };
      

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" className="text-center py-5">

                    <h1 className="fl-title-big m-0 fl-txt-container-s">AVAP for Digital Fabric & Integration Hubs</h1>
                    <p className="fl-title m-0 gradient-text fl-txt-container-s">Modern integration for complex ecosystems. Without legacy drag.</p>
                                {/*<p className="fl-text fl-txt-container" >
                                Empower every team to automate work faster and smarter with AVAP Framework’s virtual-first, low-code platform — 
                                built to orchestrate tasks, data, and systems for both humans and AI agents.
                                </p>*/}
                </section>

                {/* Subtítulo descripción */}
                <section className="text-center pb-5">
                    {/* <img
                        src={dashboard}
                        className="img-fluid mt-2 mb-4"
                        style={{ width: '70%', maxWidth: '800px', height: 'auto' }}
                    />*/}           
                    <h2 className="fl-subtitle pt-8">Weave your digital architecture into a composable, intelligent fabric.</h2>
                    <p className="fl-text text-center fl-txt-container-s">
                    AVAP Framework enables organizations to build modern, flexible integration layers, connecting legacy systems, APIs, microservices, and real-time data through intelligent orchestration. Whether you're designing a Digital Fabric or building a Digital Integration Hub, AVAP gives you the tools to simplify complexity and scale fast.</p>
                    {/*Boton Contact Us*/}  
                    <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a>
                   
                    
                    <br />
                    &nbsp;
                    <br />&nbsp;
                    
                    {/*<h2 style={{ marginTop: '40px' }} className="fl-title m-0 gradient-text fl-title m-4">Why AVAP for Cloud Providers?</h2>

                   
                        <ul className="fl-bullets fl-text text-center .fl-txt-container-s">
                        <li className="fl-bullets">Expand your service offering with high-value API Management</li>
                        <li className="fl-bullets">Increase average revenue per customer with integrated, add-on services</li>
                        <li className="fl-bullets">Provide full-featured API monitoring, control, and security</li>
                        <li className="fl-bullets">Deliver everything under your brand with flexible integration options</li>
                        <li className="fl-bullets">Maintain complete control of customer experience and business model</li> </ul>*/}
                        
                </section>
              

                <br />
                &nbsp;
                <br />&nbsp; 
               
                {/*<section className="container py-5 fl-gradientContainer mb-5" >
                <p className="fl-title-center m-0">Two Deployment Models</p><br />
                <p className="fl-subtitle text-center m-0 gradient-text">One Scalable Platform.</p>
            
                &nbsp;
                <br />&nbsp;    
                 <div className="row">
                        <div className="col-md-6 d-flex">
                            <img
                                src={icn_vision}
                                alt="Icon representing vision."
                                className="aboutIcon"
                            
                            />
                            <h3 className="fl-subtitle">1. Direct Provider Model</h3>
                            <p className="fl-text">
                            Integrate AVAP API Management directly into your platform via service APIs:
                            </p>
                                
                                <ul className="fl-bullets fl-text fl-txt-container-s" style={{ marginLeft: "7px" }}>
                                <li className="fl-bullets">White-label the solution under your own brand</li>
                                <li className="fl-bullets">Automate provisioning, monitoring, and control from your UI</li>
                                <li className="fl-bullets">Offer a native API Management experience to your customers</li>
                                <li className="fl-bullets">Seamlessly connect to your CRM, billing, and service catalog</li>
                                </ul>
                                <br/>
                            <p className="fl-text">
                            <strong style={{ fontWeight: 600 }}>Best for:</strong> Self-service platforms and tech providers with their own customer-facing portals.
                            </p>
                        </div>
                        <div className="col-md-6 pl-5">
                            <img
                                src={icn_mision}
                                alt="Icon of arrows representing mission."
                                className="mb-3 aboutIcon"
                               
                            />
                            <h3 className="fl-subtitle">2. Reseller Model</h3>
                            <p className="fl-text">
                            Distribute AVAP API Management as a ready-to-use platform:
                            </p>
                        
                                <ul className="fl-bullets fl-text  .fl-txt-container-s" style={{ marginLeft: "7px" }}>
                                <li className="fl-bullets">Control users, environments, consumption, and billing</li>
                                <li className="fl-bullets">Access to multitenant environments and centralized management</li>
                                <li className="fl-bullets">Full support and operations handled by AVAP experts</li>
                                </ul>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                            <p className="fl-text">
                            <strong style={{ fontWeight: 600 }}>Best for:</strong> Infrastructure providers looking to add robust services without complex development.
                            </p>  
                        </div>
                          
                        <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                    </div>
                            </section>*/}

                {/*Sección Tipos de Deployments */}
                <div className="container fl-gradientContainer my-5 p-5">
                <div className="fl-title text-center mb-6">
                Digital Fabric & Digital Integration Hub (DIH)
                {/*<p className="fl-subtitle text-center m-0 gradient-text">One Scalable Platform.</p>*/}
                </div>
            
                    <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items.map((item, idx) => (
                        <div key={idx} className="fl-card">
                        <img src={item.icon} alt="Icon representing 0X" className="solutionsIcon" />
                        <p className="fl-subtitle-xs">{item.title}</p>
                        {item.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                         {item.paragraphs2.map((p, i) => (
                            <p key={i} className="fl-text bold">{p}</p>
                        ))}
                        
                        {item.bullets && (
                            <ul className="fl-bullets fl-text fl-txt-container-s" style={{ marginLeft: '7px' }}>
                            {item.bullets.map((b, i) => (
                                <li key={i} className="fl-bullets">{b}</li>
                            ))}
                            </ul>
                        )}
                        {item.paragraphs3.map((p, i) => (
                            <p key={i} className="fl-text bold pt-4">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                </div>

                {/* Sección Key Features */}
                <div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <div className="fl-container">
                        <section id="products">
                            {/*   <h3 className="fl-title text-center">Our Products & Services</h3> */}
                            <br />
                            &nbsp;
                            <br />&nbsp;
                            <p className="fl-title-center m-0">How AVAP Framework Powers Your Integration Strategy</p>
                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-6">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>

                <div className="fl-card-border container text-center p-5 fl-txt-container-s">
                    <h2 style={{ marginTop: '40px' }} className="fl-title mt-0 py-2 gradient-text fl-title">Why AVAP for Digital Fabric / DIH?</h2>
                    {/*<p className='pb-4'>Digital Fabric is a flexible integration architecture that connects services, applications, and data across your enterprise using APIs, events, and composable components. It’s not a product—it’s a strategy that supports agility, real-time data exchange, and modular system evolution.
                    </p>*/}
                     {/* Sección Bullets */}
                    <ul className="fl-bullets fl-text text-center fl-txt-container-s pb-5">
                    <li className="fl-bullets">Unified platform for orchestration, exposure, and governance</li>
                    <li className="fl-bullets">Composable, API-first design to reduce dependency on monoliths</li>
                    <li className="fl-bullets">Real-time performance with decoupled architecture</li>
                    <li className="fl-bullets">Seamless integration with legacy and modern systems alike</li>
                    <li className="fl-bullets">Accelerated deployment with built-in connectors and Dev Studio tools</li> </ul>
                </div>

                {/*Sección Use Cases - bento */}
                <div className="container my-5">
                <div className="fl-title text-center">
                Use Case: Finance
                </div>
                <div>
                <p className="fl-subtitle-blue text-center mb-1">DIH: Modern Banking Without Core Disruption</p>
                <p className="text-center pb-4">A financial institution wants to launch digital products without rewriting its AS400-based core. With AVAP:</p>
                </div>
            
                    <Masonry
                    breakpointCols={breakpointColumnsObj2}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items2.map((item2, idx) => (
                        <div key={idx} className="grayGradient fl-card-s text-center">
                        {item2.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                </div>
                {/*Boton Contact Us*/}  
                <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a>

            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default DigitalFabric;
